import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material';
import { useRootStore } from '../hooks/useRootStore';
import { observer } from 'mobx-react-lite';

const GlobalErrorDialog = observer(() => {
    const { globalError } = useRootStore();
    const theme = useTheme();

    const clearError = async () => {
        globalError.reset();
    }

    return (
        <Dialog
            open={globalError.code != 0}
            onClose={clearError}
            sx={{ maxHeight:'95vh' }}
        >
            <DialogTitle sx={{ p: 0, pl: 1, color:'white', backgroundColor: theme.palette.error.main }} >Ошибка</DialogTitle>
            <DialogContent sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center', p: 0, m:1, mt:6, mb:2, minWidth: 300 }}>
                {globalError.message}
            </DialogContent>

            <DialogActions sx={{ textAlign: 'center' }}>
                <Button sx={{ margin:' 0 auto' }} onClick={clearError}>Закрыть</Button>
            </DialogActions>
        </Dialog>
    );
})

export default GlobalErrorDialog;